import React from 'react';
import { Box, Flex, Text } from '@applatform/design-system';
import { v2Colors } from 'theme';
import { ReactComponent as ZaiPaymentsLogo } from 'icons/zai-payments-logo.svg';

interface AuthCardProps {
  readonly title: string;
  readonly subtitle?: React.ReactNode;
  readonly children: React.ReactNode;
}

function AuthCard({ title, subtitle, children }: AuthCardProps) {
  return (
    <Box css={{ width: '100%', maxWidth: '392px' }}>
      <Flex
        css={{
          alignItems: 'center',
          justifyContent: 'center',
          mb: '$8',
          '& > svg': {
            display: 'block',
            width: '100%',
            minWidth: '70px',
            maxWidth: '132px',
            height: 'auto',
          },
        }}
      >
        <ZaiPaymentsLogo role="img" aria-label="Zai Payments" />
      </Flex>
      <Text
        as="h1"
        css={{
          textAlign: 'center',
          fontSize: '26px',
          m: 0,
          mb: subtitle ? '$2' : '$6',
          letterSpacing: '-0.03em',
          color: v2Colors.ink,
        }}
      >
        {title}
      </Text>
      {subtitle ? (
        <Text css={{ fontSize: '13.5px', color: v2Colors.muted, mb: '$6' }}>
          {subtitle}
        </Text>
      ) : null}
      {children}
    </Box>
  );
}

export default AuthCard;
